<!-- 配置流程节点 -->
<template>
  <div class="config-node-page">
    <div v-if="$route.query.source !== 'configCenter'" class="step-wrapper">
      <div
        v-for="(item,index) in processStep"
        :key="index"
        class="step-item"
        :class="{'active':activeStep===index, 'usable':!item.disable}"
        @click="handleClick(item,index)"
      >
        <div class="number">
          {{ index+1 }}
        </div>
        <div class="name">
          {{ item.title }}
        </div>
        <i v-show="index+1!==processStep.length" class="el-icon-arrow-right" />
      </div>
    </div>
    <!-- 创建订单 -->
    <createOrder
      v-if="activeStep==0"
      ref="createOrderRef"
      :parent-process-name="customersDetail.parentProcessName"
      :parent-process-code="customersDetail.parentProcessCode"
      :custom-field="customField"
      :customer-code="customersDetail.customerCode"
      :customers-detail="customersDetail"
      :form="form.CREATE_ORDER"
    />
    <!-- 接单 -->
    <receiveOrder
      v-if="activeStep==1"
      ref="receiveOrderRef"
      :form.sync="form.DEAL"
      :parent-process-code="customersDetail.parentProcessCode"
      @addOrCondition="addOrCondition"
      @addAdnCondition="addAdnCondition"
      @delete="Delete"
      @OrDelete="handleOrDelete"
    />
    <!-- 计费 -->
    <chargeOrder
      v-if="activeStep==2"
      ref="chargeOrderRef"
      :form="form.PRICING"
      :customers-detail="customersDetail"
      :parent-process-name="customersDetail.parentProcessName"
      :parent-process-code="customersDetail.parentProcessCode"
      :is-exist-white="isExistWhite"
      :customer-code="customersDetail.customerCode"
      @addOrCondition="addOrCondition"
      @addAdnCondition="addAdnCondition"
      @delete="Delete"
      @OrDelete="handleOrDelete"
      @addTactics="addTactics"
      @addTacticsProject="addTacticsProject"
      @deleteTacticsProject="deleteTacticsProject"
    />
    <shipperCreate
      v-if="activeStep==4"
      ref="chargeOrderRef"
      class="shipperCreate"
      @submitSuccess="handleSubmitSuccess"
    />
    <dispath
      v-if="activeStep==5"
      ref="dispathRef"
      :parent-process-name="customersDetail.parentProcessName"
      :parent-process-code="customersDetail.parentProcessCode"
      :custom-field="customField"
      :customer-code="customersDetail.customerCode"
      :form="form.DISPATCH"
    />
    <driverReceiveOrder
      v-if="activeStep==6"
      ref="driverReceiveOrderRef"
      :parent-process-name="customersDetail.parentProcessName"
      :parent-process-code="customersDetail.parentProcessCode"
      :custom-field="customField"
      :customer-code="customersDetail.customerCode"
      :form="form.DRIVER_DEAL"
    />
    <load
      v-if="activeStep==7"
      ref="loadRef"
      :parent-process-name="customersDetail.parentProcessName"
      :parent-process-code="customersDetail.parentProcessCode"
      :custom-field="customField"
      :customer-code="customersDetail.customerCode"
      :form="form.LOADING"
    />
    <!-- 底部 -->

    <div v-if="activeStep!==4">
      <fix-boottom :class="{'bottom_bar': true, 'bottom_bar_0': $route.query.source === 'configCenter'}">
        <template slot="button">
          <el-button
            type="primary"
            :loading="onlyDisabled"
            @click="handleSubmit"
          >
            {{ $route.query.source === 'configCenter' ? '保存' : '保存并下一步' }}
          </el-button>
          <el-button v-if="$route.query.source !== 'configCenter'" @click="onReturn">
            取消
          </el-button>
        </template>
      </fix-boottom>
    </div>
  </div>
</template>

<script>
import shipperCreate from '@/views/shipper/shipperCreate/index.vue';
import FixBoottom from '@/components/FixBoottom/index.vue';
import { customerProcessRuleUpdate, customerProcessRuleCreate } from '../api';
import { processStep, processModuleCode, specialModule } from '../const';
import createOrder from '../components/createOrder.vue';
import receiveOrder from '../components/receiveOrder.vue';
import chargeOrder from '../components/chargeOrder.vue';
import dispath from '../components/dispatch.vue';
import driverReceiveOrder from '../components/driverReceiveOrder.vue';
import load from '../components/load.vue';

export default {
  components: {
    createOrder, receiveOrder, chargeOrder, shipperCreate, FixBoottom, dispath, driverReceiveOrder, load,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    customField: {
      type: Object,
      default: () => { },
    },
    editProcessStep: {
      type: Number,
      default: -1,
    },
    status: {
      type: String,
      default: null,
    },
    isEidt: {
      type: Object,
      default: () => {},
    },
    customersDetail: {
      type: Object,
      default: () => {},
    },
    isExistWhite: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      processStep,
      processModuleCode,
      activeStep: 0,
      onlyDisabled: false,
    };
  },
  watch: {
    editProcessStep: {
      handler(val) {
        // 非草稿状态,
        if (this.status !== 'DRAFT') {
          this.activeStep = 0;
          return;
        }
        // 草稿状态
        if (!val || val === -1) {
          this.activeStep = 0;
          return;
        }
        this.activeStep = val > 2 ? 2 : val;
      },
      immediate: true,
    },
  },
  methods: {
    handleClick(item, index) {
      if (item.disable) {
        return;
      }
      // if (index > 2 && index !== 4 && index !== 5 && index !== 6) {
      //   return;
      // }
      // if (index > (this.editProcessStep + 1)) {
      //   return;
      // }
      this.activeStep = index;
    },
    handleBefore() {
      // 上一步
      if (this.activeStep !== 0) {
        this.activeStep -= 1;
        return;
      }
      this.$emit('handleBefore');
    },
    async handleNext() {
      // 下一步
      if (this.activeStep === 0) {
        this.handleCreateOrder();
        return;
      }
      if (this.activeStep === 1) {
        this.handleReceiveOrder();
      }
    },
    async handleCreateOrder() {
      // 创建订单
      const { res, form } = await this.$refs.createOrderRef.valiForm();
      const module = 'CREATE_ORDER';
      const {
        customerCode, carrierTenantId, parentProcessCode, ruleVersion,
      } = this.customersDetail;
      try {
        this.onlyDisabled = true;
        const params = {
          customerCode,
          carrierTenantId,
          parentProcessCode,
          ruleVersion,
          processModuleCode: module,
          processRules: [...res].filter((item) => !specialModule[module].includes(item.ruleCode)).filter((t) => t.ruleCode !== 'SKU_IGNORE_WEIGHT_VOLUME'),
        };
        const method = !this.isEidt[module] ? customerProcessRuleCreate : customerProcessRuleUpdate;
        await method(params);
        this.$emit('getConfigNodeParams', {
          key: module,
          formParams: form,
        });
        this.activeStep += 1;
        this.onlyDisabled = false;
      } catch (e) {
        this.onlyDisabled = false;
      }
    },
    async handleReceiveOrder() {
      // 接单
      const { res, form } = await this.$refs.receiveOrderRef.valiForm();
      const module = 'DEAL';
      const {
        customerCode, carrierTenantId, parentProcessCode, ruleVersion,
      } = this.customersDetail;
      try {
        this.onlyDisabled = true;
        const params = {
          customerCode,
          carrierTenantId,
          parentProcessCode,
          ruleVersion,
          processModuleCode: module,
        };
        const rulesList = [...res].filter((item) => !specialModule[module].includes(item.ruleCode));
        const AUTO_DEAL_CONDITION = rulesList.find((item) => item.ruleCode === 'AUTO_DEAL_CONDITION');
        if (res.find((item) => item.ruleCode === 'AUTO_DEAL').ruleValue.flag && AUTO_DEAL_CONDITION.ruleValue && AUTO_DEAL_CONDITION.ruleValue.condition.length) {
          params.processRules = rulesList;
        } else {
          params.processRules = rulesList.filter((item) => item.ruleCode !== 'AUTO_DEAL_CONDITION');
        }
        const method = !this.isEidt[module] ? customerProcessRuleCreate : customerProcessRuleUpdate;
        await method(params);
        this.$emit('getConfigNodeParams', {
          key: module,
          formParams: form,
        });
        this.$message.success('保存成功');
        if (this.$route.query.source !== 'configCenter') {
          this.activeStep += 1;
        }
        this.onlyDisabled = false;
      } catch (e) {
        this.onlyDisabled = false;
      }
    },
    async handleChargeOrder() {
      // 计费
      const { res, form } = await this.$refs.chargeOrderRef.valiForm();
      const module = 'PRICING';
      const {
        customerCode, carrierTenantId, parentProcessCode, ruleVersion,
      } = this.customersDetail;
      try {
        this.onlyDisabled = true;
        const params = {
          customerCode,
          carrierTenantId,
          parentProcessCode,
          ruleVersion,
          processModuleCode: module,
        };
        const rulesList = [...res].filter((item) => !specialModule[module].includes(item.ruleCode));
        const PRICING_CONDITION = rulesList.find((item) => item.ruleCode === 'PRICING_CONDITION');
        if (res.find((item) => item.ruleCode === 'PRICING_CHECK').ruleValue.flag && PRICING_CONDITION.ruleValue.condition && PRICING_CONDITION.ruleValue.condition.length) {
          params.processRules = rulesList;
        } else {
          params.processRules = rulesList.filter((item) => item.ruleCode !== 'PRICING_CONDITION');
        }
        const method = !this.isEidt[module] ? customerProcessRuleCreate : customerProcessRuleUpdate;
        await method(params);
        this.$emit('getConfigNodeParams', {
          key: module,
          formParams: form,
        });
        this.activeStep += 2;
        this.onlyDisabled = false;
      } catch (e) {
        this.onlyDisabled = false;
      }
    },
    // 派车
    async handelDispath() {
      const { res, form } = await this.$refs.dispathRef.valiForm();
      // TODO:
      console.log('handelDispath--', res, form);
      const module = 'DISPATCH';
      const {
        customerCode, carrierTenantId, parentProcessCode, ruleVersion,
      } = this.customersDetail;
      try {
        this.onlyDisabled = true;
        const params = {
          customerCode,
          carrierTenantId,
          parentProcessCode,
          ruleVersion,
          processModuleCode: module,
          processRules: res,
        };
        const method = !this.isEidt[module] ? customerProcessRuleCreate : customerProcessRuleUpdate;
        await method(params);
        this.$emit('getConfigNodeParams', {
          key: module,
          formParams: form,
        });
        this.$message.success('保存成功');
        if (this.$route.query.source !== 'configCenter') {
          this.activeStep += 1;
        }
        // this.activeStep += 1;
        // this.$emit('allConfig');
        this.onlyDisabled = false;
      } catch (e) {
        this.onlyDisabled = false;
      }
    },
    // 司机接单
    async handelDriverReceiveOrder() {
      const { res, form } = await this.$refs.driverReceiveOrderRef.valiForm();
      const module = 'DRIVER_DEAL';
      const {
        customerCode, carrierTenantId, parentProcessCode, ruleVersion,
      } = this.customersDetail;
      try {
        this.onlyDisabled = true;
        const params = {
          customerCode,
          carrierTenantId,
          parentProcessCode,
          ruleVersion,
          processModuleCode: module,
          processRules: res,
        };
        const method = !this.isEidt[module] ? customerProcessRuleCreate : customerProcessRuleUpdate;
        await method(params);
        this.$emit('getConfigNodeParams', {
          key: module,
          formParams: form,
        });
        this.activeStep += 1;
        // this.$emit('allConfig');
        this.onlyDisabled = false;
      } catch (e) {
        this.onlyDisabled = false;
      }
    },
    // 装载
    async handelLoad() {
      const { res, form } = await this.$refs.loadRef.valiForm();
      const module = 'LOADING';
      const {
        customerCode, carrierTenantId, parentProcessCode, ruleVersion,
      } = this.customersDetail;
      try {
        this.onlyDisabled = true;
        const params = {
          customerCode,
          carrierTenantId,
          parentProcessCode,
          ruleVersion,
          processModuleCode: module,
          processRules: res,
        };
        const method = !this.isEidt[module] ? customerProcessRuleCreate : customerProcessRuleUpdate;
        await method(params);
        this.$emit('getConfigNodeParams', {
          key: module,
          formParams: form,
        });
        // this.activeStep += 1;
        this.$emit('allConfig');
        this.onlyDisabled = false;
      } catch (e) {
        this.onlyDisabled = false;
      }
    },
    handleSubmit() {
      // 提交
      switch (this.activeStep) {
        case 0:
          this.handleCreateOrder();
          break;
        case 1:
          this.handleReceiveOrder();
          break;
        case 2:
          this.handleChargeOrder();
          break;
        case 4:
          console.log('I own a snake');
          break;
        case 5:
          this.handelDispath();
          break;
        case 6:
          this.handelDriverReceiveOrder();
          break;
        case 7:
          this.handelLoad();
          break;
        default:
          break;
      }
    },
    handleSubmitSuccess() {
      // this.$emit('allConfig');
      this.activeStep += 1;
    },
    onReturn() {
      this.$router.go(-1);
    },
    addOrCondition(module, ruleCode) {
      this.$emit('addOrCondition', module, ruleCode);
    },
    addAdnCondition(index, module, ruleCode) {
      this.$emit('addAdnCondition', index, module, ruleCode);
    },
    Delete(value, module, ruleCode) {
      this.$emit('delete', value, module, ruleCode);
    },
    handleOrDelete(value, module, ruleCode) {
      this.$emit('OrDelete', value, module, ruleCode);
    },
    addTactics(module, ruleCode) {
      this.$emit('addTactics', module, ruleCode);
    },
    addTacticsProject(data, module, ruleCode) {
      this.$emit('addTacticsProject', data, module, ruleCode);
    },
    deleteTacticsProject(data, module, ruleCode) {
      this.$emit('deleteTacticsProject', data, module, ruleCode);
    },
  },
};
</script>

<style lang="scss" scoped>
.config-node-page{
  width:100%;
  flex:1;
  background: #fff;
  box-sizing: border-box;
  position:relative;
  margin-bottom: 40px;
  .step-wrapper{
    display:flex;
    padding:24px 24px 0;
    position: sticky;
    top:0;
    left:0;
    background: #fff;
    z-index:100;
    .step-item{
      flex:1;
      border-bottom:1px solid #EBECEE;
      display: flex;
      align-items: center;
      padding-bottom:9px;
      box-sizing: border-box;
      cursor: pointer;
      .number{
        width:20px;
        height:20px;
        text-align: center;
        line-height: 20px;
        border-radius: 100%;
        border:2px solid #B3B7BE;
        color:#B3B7BE;
        margin-right: 8px;
      }
      .name{
        color:#B3B7BE;
        font-weight: 500;
        flex:1;
      }
      .el-icon-arrow-right{
        color:#D9DBDE;
        margin-right:20px;
      }
    }
    .usable{
      .number{
        color: #7E8694 ;
        border:2px solid #7E8694;
      }
      .name{
        color: #7E8694 ;
      }
    }
    .active{
      border-bottom-color: #059E84;
      .number{
        color:#fff;
        background:#059E84;
        border-color: #059E84;
      }
      .name{
        color:#059E84;
        font-weight:600
      }
    }
  }
  .next-wrapper{
    text-align: center;
    border-bottom: 1px solid #D9DBDE;
    padding:16px;
    box-sizing: border-box;
  }
  .fixed-footer{
    height:56px;
    line-height: 56px;
    position:absolute;
    bottom:-24px;
    left:-24px;
    width:calc(100% + 48px);
    padding-left:24px;
    box-sizing: border-box;
    background: #fff;
    box-shadow: 0px -5px 5px -5px rgba(0, 0, 0, 0.2);
  }
}
::v-deep.bottom_bar{
  .align-right{
    text-align: left;
  }

  &.bottom_bar_0 {
    left: 0 !important;
  }
}
.shipperCreate{
  height: 100%;
}
</style>
